import { CEO_PERMISSION_ID, CEO_ROLE_ID } from './ceoDashboard.constants';

/** Only role 100 with permission 1 may open the CEO dashboard; the server checks the same. */
export const isCeo = (
  roleId: number | string | null | undefined,
  permissionId: number | string | null | undefined,
): boolean => Number(roleId) === CEO_ROLE_ID && Number(permissionId) === CEO_PERMISSION_ID;

/** A 403 from the server, whether it arrives as an `ApiError` or a raw axios error. */
export const isForbiddenError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false;
  const { status, response } = error as { status?: unknown; response?: { status?: unknown } };
  return Number(status) === 403 || Number(response?.status) === 403;
};
